import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { useEffect, useRef, useMemo } from 'react';
import styles from './d0f4ef905db6ff4aa2210fbf8d7198de6be0f13a621b3369ac7134651a7e3c08.cfe-internal.js';
import '../Button/dc121e2f212159f291e6ef8624b9668aa503817b9cff55ab585c7bb9b1925bf2.cfe-internal.js';
import Saturation from './08394fb723c4d72a3e924b24c6b4fbe32f3891efeae7a6b84e5be291b638971b.cfe-internal.js';
import HexInput from './bb4efa406dcb650622e527186c332cae3bdb7d26f06506c000c2cea8510ee663.cfe-internal.js';
import Swatch from './b71dcdfc071013f1e741831ccc420c5c5fa649e8f39e3a8c4f834d2d0d933764.cfe-internal.js';
import '../../icons/index.es.js';
import Hue from './c54187e4dd1cc9ef0f18095c42fc87586d7b7cc73be71ab994daf6416a2eb94d.cfe-internal.js';
import Alpha from './6e56e2f07bca329c1f7b9de913b91a4eb06ebbce3cecbe708b7a6de54b140dd4.cfe-internal.js';
import Color from './f9441c2ea6109737bdb296a369121057661733f60c56b135bf16bba91985f631.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import { DEFAULT_SWATCH_COLORS } from './ace2ee98f4547baf3a68fd06058eed8ba5ef711204c53b3ae59eeb3e930d186e.cfe-internal.js';
import useClickOutside from '../../hooks/useClickOutside/093095b07737bf7e3954fcb01b077308dc339e5b14c18c3bec4dc276dceea639.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';
import Popper from '../../utils/Popper/53f589867426c0fe9404d76ffe1e6e0db92964f6396b0b62988d89a525e5a08b.cfe-internal.js';
import { FLYOUT_POPPER_OFFSET } from '../../utils/f5e4d8f62716db08736bdf8cd2bfb32640bfafeca586ef59cc354009b4870444.cfe-internal.js';
import { Button } from '../Button/f53b28c61b990709f9826a4237716d0d9d87dd41248bc45b1ed125999e0b4156.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import ChevronDownIcon from '../../icons/components/7c7c780956cb4e93fe69a1384927ee5fbe6526f5bb2422c9d44843841947bab7.cfe-internal.js';

var _excluded = ["data-testid", "defaultColor", "color", "className", "enableAlpha", "onChange", "swatches", "zIndex"];
var ColorPicker = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var dataTestId = _ref['data-testid'],
    _ref$defaultColor = _ref.defaultColor,
    defaultColor = _ref$defaultColor === void 0 ? '#000000' : _ref$defaultColor,
    externalColor = _ref.color,
    className = _ref.className,
    _ref$enableAlpha = _ref.enableAlpha,
    enableAlpha = _ref$enableAlpha === void 0 ? false : _ref$enableAlpha,
    onChange = _ref.onChange,
    _ref$swatches = _ref.swatches,
    swatches = _ref$swatches === void 0 ? DEFAULT_SWATCH_COLORS : _ref$swatches,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React__default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];
  var _React$useState3 = React__default.useState(new Color(externalColor !== null && externalColor !== void 0 ? externalColor : defaultColor)),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    color = _React$useState4[0],
    setColor = _React$useState4[1];
  useEffect(function () {
    if (externalColor) setColor(new Color(externalColor));
  }, [externalColor]);
  function handleChange(rawColor, e) {
    var nextColor = new Color(rawColor);
    setColor(nextColor);
    onChange === null || onChange === void 0 || onChange(nextColor.getValue(), e);
  }
  var alpha;
  var width = 136;
  if (enableAlpha) {
    alpha = /*#__PURE__*/React__default.createElement(Alpha, {
      className: styles.colorPickerAlpha,
      alpha: color.toHSB().a,
      hsl: color.toHSL(),
      onChange: handleChange
    });
    width += 20;
  }
  var swatchComponent;
  if (swatches && swatches.length > 0) {
    swatchComponent = /*#__PURE__*/React__default.createElement("div", {
      className: styles.colorPickerSwatches
    }, _mapInstanceProperty(swatches).call(swatches, function (swatchColor) {
      return /*#__PURE__*/React__default.createElement(Swatch, {
        key: swatchColor,
        className: styles.colorPickerSwatch,
        color: swatchColor,
        onClick: handleChange
      });
    }));
  }
  var anchorRef = useRef(null);
  var popperRef = useRef(null);
  var refs = useMemo(function () {
    return [anchorRef, popperRef];
  }, []);
  useClickOutside(refs, function () {
    return setShow(false);
  });
  var content = /*#__PURE__*/React__default.createElement("div", {
    className: styles.colorPicker,
    style: {
      width: width,
      zIndex: zIndex
    },
    ref: popperRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.colorPickerSliderContainer
  }, /*#__PURE__*/React__default.createElement(Saturation, {
    hsb: color.toHSB(),
    onChange: handleChange
  }), /*#__PURE__*/React__default.createElement(Hue, {
    className: styles.colorPickerHue,
    hsb: color.toHSB(),
    onChange: handleChange
  }), alpha), swatchComponent, /*#__PURE__*/React__default.createElement(HexInput, {
    hex: color.toHex(),
    swatchColor: color.toString('hsla'),
    onChange: handleChange,
    className: styles.colorPickerHex,
    "data-testid": getSubDataTestId(dataTestId, 'Hex')
  }));
  return /*#__PURE__*/React__default.createElement(Popper, {
    open: show,
    placement: "bottom-start",
    popper: content,
    modifiers: [{
      name: 'offset',
      options: {
        offset: FLYOUT_POPPER_OFFSET
      }
    }],
    anchor: /*#__PURE__*/React__default.createElement(Button, _extends({}, rest, {
      "data-testid": dataTestId,
      ref: mergeRefs(ref, anchorRef),
      className: className,
      onClick: function onClick() {
        return setShow(function (v) {
          return !v;
        });
      }
    }), /*#__PURE__*/React__default.createElement("span", {
      className: styles.colorPickerBtnColor,
      style: {
        backgroundColor: color.toString('rgba')
      }
    }), /*#__PURE__*/React__default.createElement(ChevronDownIcon, {
      className: styles.colorPickerBtnIcon,
      size: "medium",
      "aria-hidden": "true"
    }))
  });
});

export { ColorPicker as default };
